'use client';

import Image from 'next/image';
import { Progress, Flex } from '@chakra-ui/react';

const LoadingSpinner = () => {
  return (
    <Flex
      direction="column"
      justifyContent="center"
      alignItems="center"
      gap="20px"
    >
      <Image
        src="/assets/ugo_logo_no_space.svg"
        alt="UGO"
        width={110.49528301886792}
        height={50}
      />
      <Progress
        w="200px"
        h="4px"
        size="xl"
        colorScheme="blackAlpha"
        isIndeterminate
      />
    </Flex>
  );
};

export default LoadingSpinner;

export const PageLoadingSpinner = () => {
  return (
    <Flex
      flex="1"
      align="center"
      justify="center"
    >
      <LoadingSpinner />
    </Flex>
  );
};
